import { useState, useEffect } from 'react';
import { Grid, TextField, Modal, Box, FormControl } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { forgotPassword, resetPassword } from '../../../../service/CognitoAuthService';
import { SubmitButton, AlertComponent, FormButton } from '../../../../components';
import FayvenLogo from '../../../../assets/img/fayven_logo.png';
import './style.css';
import ResetPass from './resetPass';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  // height: 600,
  bgcolor: '#ffffff',
  border: '0px solid #000',
  boxShadow: 24,
  p: 4,
  '@media (max-width: 600px)': {
    width: 300,
    overflowY: 'auto',
    maxHeight: 550,
  },
  '@media (max-height: 500px)': {
    width: 300,
    overflowY: 'scroll',
    maxHeight: 380,
  },
};

export default function Forgot({ onSuccess, open, setOpen }) {
  const [handleErrors, setHandleErrors] = useState({
    showAlert: false,
    type: '',
    title: '',
    description: '',
  });
  const [email, setEmail] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(open);
  const handleClose = () => setOpen(false);
  const useStyles = makeStyles({
    input: {
      background: 'white',
    },
  });

  useEffect(() => {
    setHandleErrors({
      showAlert: false,
      type: '',
      title: '',
      description: '',
    });
  }, []);

  const validationSchema = yup.object({
    email: yup
      .string('Enter your email')
      .email('Enter a valid email')
      .required('Email is required'),
  });
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setEmail(values.email);
        const result = await forgotPassword(values.email);
        if (result) {
          setIsEmailSent(false);
        }
        setIsEmailSent(false);
        setTimeout(() => {
          resetForm();
        }, 2000);
      } catch (err) {
        setHandleErrors(() => ({
          ...handleErrors,
          show: true,
          type: 'error',
          title: 'Error Send Email',
          description: 'Email Invalid',
        }));
      }
    },
  });

  useEffect(() => {
    setIsEmailSent(true);
  }, []);

  const classes = useStyles();
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style} className="form-login">
          <Grid item xs={12} className="grid-logo">
            <img src={FayvenLogo} alt="logo" className="img-logo" />
          </Grid>
          <Grid item xs={12} className="grid-space-line" />
          {isEmailSent ? (
            <div>
              <Grid item xs={12} className="grid-title">
                Forgot your password
              </Grid>
              <Grid item xs={12} sx={{ py: 3 }} className="grid-text">
                Enter the email address associated with your account, and we’ll email you a code to
                reset your password.
              </Grid>
              <form key="mail1" style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
                <TextField
                  inputProps={{ className: classes.input }}
                  style={{ marginTop: '5px' }}
                  fullWidth
                  autoComplete="off"
                  id="email"
                  name="email"
                  placeholder="Email"
                  type="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                <Grid item xs={12} className="grid-space-btn" />
                <FormButton type="submit">Send reset code</FormButton>
              </form>
            </div>
          ) : (
            <div>
              <Grid item xs={12} className="grid-title">
                Enter the code sent to your email.
              </Grid>
              <ResetPass
                email={email}
                setHandleErrors={setHandleErrors}
                setIsEmailSent={setIsEmailSent}
                handleClose={handleClose}
              />
            </div>
          )}
          {handleErrors.showAlert ? (
            <AlertComponent
              title={handleErrors.title}
              content={handleErrors.description}
              severity={handleErrors.type}
            />
          ) : null}
        </Box>
      </Modal>
    </div>
  );
}

Forgot.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};
